// React Context lets you share data across your whole app without
// passing it manually through every component.
// This AuthContext stores the current user and login/logout functions.

import React, { createContext, useState, useEffect, useContext } from 'react';
import api from '../api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // When the app loads, check if there's a saved token and fetch the user
  useEffect(() => {
    const token = localStorage.getItem('tandm_token');
    if (token) {
      api.get('/auth/me')
        .then(res => setUser(res.data.user))
        .catch(() => localStorage.removeItem('tandm_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('tandm_token', token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('tandm_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook — lets any component access auth with just: const { user } = useAuth()
export const useAuth = () => useContext(AuthContext);
